import { useContext } from "react";
import { MizFileContext } from "../contexts/MizFileContext";
import { FragOrder } from "../lib/models/FragOrder";

export function useDownloadMiz() {
  const { download } = useContext(MizFileContext);

  return (fo: FragOrder) => download(fo.id);
}
